<div class="modal-div">
  <div class="popup-header">
    <span class="popup-title header-num">{{ configs.title }}</span>
    <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
        alt="Close"
      />
    </button>
  </div>

  <div class="modal-body">
    <div class="info-section">
      <div class="info-column-one">
        <div class="info-item" *ngFor="let key of getDataKeys().slice(0, 2)">
          <span class="info-label">{{ formatLabel(key) }}:</span>
          <span class="info-value">{{ configs.data[key] }}</span>
        </div>
      </div>
      <div class="info-column-two">
        <div class="info-item" *ngFor="let key of getDataKeys().slice(2)">
          <span class="info-label">{{ formatLabel(key) }}:</span>
          <span class="info-value">{{ configs.data[key] }}</span>
        </div>
      </div>
    </div>

    <app-dynamic-form
      [form]="dynamicForm"
      [formFields]="configs.fields"
      (modelChange)="onFormChange($event)"
    ></app-dynamic-form>

    <div class="device-info-section" *ngIf="selectedDevice">
      <div class="device-info-title">Device Info</div>
      <div class="info-section">
        <div class="info-column-one">
          <div
            class="info-item"
            *ngFor="let key of getDeviceKeys().slice(0, 3)"
          >
            <span class="info-label">{{ formatLabel(key) }}:</span>
            <span class="info-value" *ngIf="key !== 'deviceType' && key !== 'platform'">{{ selectedDevice[key] }}</span>
            <span class="device-type-chip" *ngIf="key === 'deviceType'">{{ selectedDevice[key] }}</span>
            <span class="platform-value" *ngIf="key === 'platform'">
              <img *ngIf="getPlatformIcon(selectedDevice[key])" 
                   [src]="getPlatformIcon(selectedDevice[key])" 
                   class="platform-icon" 
                   [alt]="selectedDevice[key]" />
              <span>{{ selectedDevice[key] }}</span>
            </span>
          </div>
        </div>
        <div class="info-column-two">
          <div class="info-item" *ngFor="let key of getDeviceKeys().slice(3)">
            <span class="info-label">{{ formatLabel(key) }}:</span>
            <span class="info-value" *ngIf="key !== 'deviceType' && key !== 'platform'">{{ selectedDevice[key] }}</span>
            <span class="device-type-chip" *ngIf="key === 'deviceType'">{{ selectedDevice[key] }}</span>
            <span class="platform-value" *ngIf="key === 'platform'">
              <img *ngIf="getPlatformIcon(selectedDevice[key])" 
                   [src]="getPlatformIcon(selectedDevice[key])" 
                   class="platform-icon" 
                   [alt]="selectedDevice[key]" />
              <span>{{ selectedDevice[key] }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer d-flex justify-content-end">
    <button
      type="submit"
      class="btn btn-accello-secondary d-block"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button
      type="submit"
      class="btn btn-accello-primary-light d-block"
      (click)="save()"
      [disabled]="!dynamicForm.valid"
    >
      {{ configs.saveBtnText }}
    </button>
  </div>
</div>
